import { createStyles, makeStyles } from '@material-ui/styles';
import * as classNames from 'classnames';
import * as React from 'react';
import { FC, useEffect } from 'react';
import mediaQueries from 'src/constants/responsive';
import spacing from 'src/constants/spacing';
import stylesheet, { bodyFontSize, divisorColor, mainColor, secondaryColor } from 'src/constants/stylesheet';
import useRouter from 'use-react-router';
import Diaporama from './Diaporama';
import ExhibitionsPreview from './ExhibitionsPreview';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      position: 'relative',
      // overflowX: 'hidden',
    },
    section: {
      position: 'relative',
      boxSizing: 'border-box',

      '&:after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: 1,
        // transform: 'translateX(-50%)',
        backgroundColor: divisorColor
      },
    },
    sectionNews: {
      boxSizing: 'border-box',
      [mediaQueries.Mobile]: {
        paddingLeft: spacing.Gutter.Mobile,
        paddingRight: spacing.Gutter.Mobile,
        paddingBottom: spacing.Gutter.Mobile,
      },
      [mediaQueries.Tablet]: {
        height: `calc(100vh - ${spacing.MenuHeight.Tablet}px)`,
        paddingLeft: spacing.Gutter.Tablet,
        paddingRight: spacing.Gutter.Tablet,
        paddingBottom: spacing.Gutter.Tablet,
      },
      [mediaQueries.Laptop]: {
        height: `calc(100vh - ${spacing.MenuHeight.Laptop}px)`,
        paddingLeft: spacing.Gutter.Laptop,
        paddingRight: spacing.Gutter.Laptop,
        paddingBottom: spacing.Gutter.Laptop,
      },
      [mediaQueries.Desktop]: {
        height: `calc(100vh - ${spacing.MenuHeight.Desktop}px)`,
        paddingLeft: spacing.Gutter.Desktop,
        paddingRight: spacing.Gutter.Desktop,
        paddingBottom: spacing.Gutter.Desktop,
      },
      [mediaQueries.BigDesktop]: {
        height: `calc(100vh - ${spacing.MenuHeight.BigDesktop}px)`,
        paddingLeft: spacing.Gutter.BigDesktop,
        paddingRight: spacing.Gutter.BigDesktop,
        paddingBottom: spacing.Gutter.BigDesktop,
      },
    },
    sliderOuter: {
      position: 'relative',

      [mediaQueries.AfterMobile]: {
        height: '100%',
      }
    },
    sectionExhibitions: {
      [mediaQueries.Mobile]: {
        paddingLeft: `${spacing.Gutter.Mobile - spacing.GutterGrid.Mobile / 2}px`,
        paddingRight: `${spacing.Gutter.Mobile - spacing.GutterGrid.Mobile / 2}px`,
        paddingBottom: spacing.Gutter.Mobile / 2,
      },
      [mediaQueries.Tablet]: {
        paddingLeft: `${spacing.Gutter.Tablet - spacing.GutterGrid.Tablet / 2}px`,
        paddingRight: `${spacing.Gutter.Tablet - spacing.GutterGrid.Tablet / 2}px`,
        paddingBottom: spacing.Gutter.Tablet / 2,
      },
      [mediaQueries.Laptop]: {
        paddingLeft: `${spacing.Gutter.Laptop - spacing.GutterGrid.Laptop / 2}px`,
        paddingRight: `${spacing.Gutter.Laptop - spacing.GutterGrid.Laptop / 2}px`,
        paddingBottom: spacing.Gutter.Laptop / 2,
      },
      [mediaQueries.Desktop]: {
        paddingLeft: `${spacing.Gutter.Desktop - spacing.GutterGrid.Desktop / 2}px`,
        paddingRight: `${spacing.Gutter.Desktop - spacing.GutterGrid.Desktop / 2}px`,
        paddingBottom: spacing.Gutter.Desktop / 2,
      },
      [mediaQueries.BigDesktop]: {
        paddingLeft: `${spacing.Gutter.BigDesktop - spacing.GutterGrid.BigDesktop / 2}px`,
        paddingRight: `${spacing.Gutter.BigDesktop - spacing.GutterGrid.BigDesktop / 2}px`,
        paddingBottom: spacing.Gutter.BigDesktop / 2,
      },
    },

    content: {
      display: 'flex',
      flexWrap: 'wrap',
    },

    // newsItem
    titles: {
      width: '100%',

      [mediaQueries.Mobile]: {
        marginBottom: spacing.Gutter.Mobile,
        order: 2
      }
    },
    newsItemTitlesLink: {
      '&:hover': {
        color: 'inherit'
      },
    },
    titleFont: {
      ...stylesheet.MainTitle,
    },
    subTitleFont: {
      ...stylesheet.SubTitle,
    },
    overTitle: {
      boxSizing: 'border-box',

      [mediaQueries.Mobile]: {
        width: `100%`,
        order: 2
      },
      [mediaQueries.Mobile]: {
        paddingLeft: spacing.GutterGrid.Mobile / 2,
        paddingRight: spacing.GutterGrid.Mobile / 2,
      },
      [mediaQueries.Tablet]: {
        width: `${2 / 3 * 100}%`,
        paddingLeft: spacing.GutterGrid.Tablet / 2,
        paddingRight: spacing.GutterGrid.Tablet / 2,
        marginLeft: 'auto',
      },
      [mediaQueries.Laptop]: {
        width: `${2 / 3 * 100}%`,
        paddingLeft: spacing.GutterGrid.Laptop / 2,
        paddingRight: spacing.GutterGrid.Laptop / 2,
        marginLeft: 'auto',
      },
      [mediaQueries.Desktop]: {
        width: `${2 / 3 * 100}%`,
        paddingLeft: spacing.GutterGrid.Desktop / 2,
        paddingRight: spacing.GutterGrid.Desktop / 2,
        marginLeft: 'auto',
      },
      [mediaQueries.BigDesktop]: {
        width: `${2 / 4 * 100}%`,
        paddingLeft: spacing.GutterGrid.BigDesktop / 2,
        paddingRight: spacing.GutterGrid.BigDesktop / 2,
        marginLeft: 'auto',
      },
    },
    title: {
      boxSizing: 'border-box',
      [mediaQueries.Mobile]: {
        paddingLeft: spacing.GutterGrid.Mobile / 2,
        paddingRight: spacing.GutterGrid.Mobile / 2,
        marginBottom: spacing.GutterGrid.Mobile / 2,
      },
      [mediaQueries.Tablet]: {
        width: `${2 / 3 * 100}%`,
        paddingLeft: spacing.GutterGrid.Tablet / 2,
        paddingRight: spacing.GutterGrid.Tablet / 2,
        marginBottom: spacing.GutterGrid.Tablet / 2,
        marginLeft: 'auto',
      },
      [mediaQueries.Laptop]: {
        width: `${2 / 3 * 100}%`,
        paddingLeft: spacing.GutterGrid.Laptop / 2,
        paddingRight: spacing.GutterGrid.Laptop / 2,
        marginBottom: spacing.GutterGrid.Laptop / 2,
        marginLeft: 'auto',
      },
      [mediaQueries.Desktop]: {
        width: `${2 / 3 * 100}%`,
        paddingLeft: spacing.GutterGrid.Desktop / 2,
        paddingRight: spacing.GutterGrid.Desktop / 2,
        marginBottom: `${10 / bodyFontSize.Desktop}rem`,
        marginLeft: 'auto',
      },
      [mediaQueries.BigDesktop]: {
        width: `${2 / 4 * 100}%`,
        paddingLeft: spacing.GutterGrid.BigDesktop / 2,
        paddingRight: spacing.GutterGrid.BigDesktop / 2,
        marginBottom: `${15 / bodyFontSize.Desktop}rem`,
        marginLeft: 'auto',
      },
    },
    subTitle: {
      marginLeft: 'auto',
      boxSizing: 'border-box',

      [mediaQueries.Mobile]: {
        width: `100%`,
        paddingLeft: spacing.GutterGrid.Mobile / 2,
        paddingRight: spacing.GutterGrid.Mobile / 2,
        order: 2
      },
      [mediaQueries.Tablet]: {
        width: `${2 / 3 * 100}%`,
        paddingLeft: spacing.GutterGrid.Tablet / 2,
        paddingRight: spacing.GutterGrid.Tablet / 2,
        marginBottom: `${10 / bodyFontSize.Desktop}rem`,
        marginLeft: 'auto',
      },
      [mediaQueries.Laptop]: {
        width: `${2 / 3 * 100}%`,
        paddingLeft: spacing.GutterGrid.Laptop / 2,
        paddingRight: spacing.GutterGrid.Laptop / 2,
        marginBottom: `${10 / bodyFontSize.Desktop}rem`,
        marginLeft: 'auto',
      },
      [mediaQueries.Desktop]: {
        width: `${2 / 3 * 100}%`,
        paddingLeft: spacing.GutterGrid.Desktop / 2,
        paddingRight: spacing.GutterGrid.Desktop / 2,
        marginBottom: `${10 / bodyFontSize.Desktop}rem`,
        marginLeft: 'auto',
      },
      [mediaQueries.BigDesktop]: {
        width: `${2 / 4 * 100}%`,
        paddingLeft: spacing.GutterGrid.BigDesktop / 2,
        paddingRight: spacing.GutterGrid.BigDesktop / 2,
        marginBottom: `${15 / bodyFontSize.Desktop}rem`,
        marginLeft: 'auto',
      },
    },

    newsItemNav: {
      boxSizing: 'border-box',

      [mediaQueries.Mobile]: {
        width: `100%`,
        paddingLeft: spacing.GutterGrid.Mobile / 2,
        paddingRight: spacing.GutterGrid.Mobile / 2,
        marginBottom: spacing.Gutter.Mobile,
        order: 1
      },
      [mediaQueries.Tablet]: {
        width: `${1 / 3 * 100}%`,
        paddingLeft: spacing.GutterGrid.Tablet / 2,
        paddingRight: spacing.GutterGrid.Tablet / 2,
      },
      [mediaQueries.Laptop]: {
        width: `${1 / 3 * 100}%`,
        paddingLeft: spacing.GutterGrid.Laptop / 2,
        paddingRight: spacing.GutterGrid.Laptop / 2,
      },
      [mediaQueries.Desktop]: {
        width: `${1 / 3 * 100}%`,
        paddingLeft: spacing.GutterGrid.Desktop / 2,
        paddingRight: spacing.GutterGrid.Desktop / 2,
      },
      [mediaQueries.BigDesktop]: {
        width: `${1 / 4 * 100}%`,
        paddingLeft: spacing.GutterGrid.BigDesktop / 2,
        paddingRight: spacing.GutterGrid.BigDesktop / 2,
      },
    },
    navItem: {
      ...stylesheet.SubTitle,
      color: secondaryColor,
      '&:hover': {
        color: mainColor
      }
    },
    navItemActive: {
      color: mainColor
    },
    newsItemInfos: {
      boxSizing: 'border-box',

      [mediaQueries.Mobile]: {
        width: `100%`,
        paddingLeft: spacing.GutterGrid.Mobile / 2,
        paddingRight: spacing.GutterGrid.Mobile / 2,
        marginBottom: spacing.Gutter.Mobile,
        order: 3
      },
      [mediaQueries.Tablet]: {
        width: `${2 / 3 * 100}%`,
        paddingLeft: spacing.GutterGrid.Tablet / 2,
        paddingRight: spacing.GutterGrid.Tablet / 2,
        marginBottom: spacing.Gutter.Tablet,
        marginLeft: 'auto',
      },
      [mediaQueries.Laptop]: {
        width: `${2 / 3 * 100}%`,
        paddingLeft: spacing.GutterGrid.Laptop / 2,
        paddingRight: spacing.GutterGrid.Laptop / 2,
        marginBottom: spacing.Gutter.Laptop,
        marginLeft: 'auto',
      },
      [mediaQueries.Desktop]: {
        width: `${2 / 3 * 100}%`,
        paddingLeft: spacing.GutterGrid.Desktop / 2,
        paddingRight: spacing.GutterGrid.Desktop / 2,
        marginBottom: spacing.Gutter.Desktop,
        marginLeft: 'auto',
      },
      [mediaQueries.BigDesktop]: {
        width: `${2 / 4 * 100}%`,
        paddingLeft: spacing.GutterGrid.BigDesktop / 2,
        paddingRight: spacing.GutterGrid.BigDesktop / 2,
        marginBottom: spacing.Gutter.BigDesktop,
        marginLeft: 'auto',
      },
    },
    newsItemInfo: {
      ...stylesheet.Introduction,
    },
    newsItemInfoMarginBottom: {
      [mediaQueries.AfterMobile]: {
        marginBottom: `${10 / bodyFontSize.Desktop}rem`
      }
    },
    notes: {},
    newsItemFigureOuter: {
      width: '100%',
      boxSizing: 'border-box',

      [mediaQueries.Mobile]: {
        paddingLeft: spacing.GutterGrid.Mobile / 2,
        paddingRight: spacing.GutterGrid.Mobile / 2,
        marginBottom: spacing.Gutter.Mobile,
        order: 4
      },
      [mediaQueries.AfterMobile]: {
        paddingLeft: spacing.GutterGrid.Desktop / 2,
        paddingRight: spacing.GutterGrid.Desktop / 2,
        marginBottom: spacing.Gutter.Desktop,
      }
    },
    newsItemFigure: {
      position: 'relative',
      height: 0,
      overflow: 'hidden',
    },
    newsItemImg: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      transition: 'transform 0.4s ease-out'
    },
    newsItemLink: {
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,

      '&:hover img': {
        transform: 'scale(1.05)'
      }
    },

    // grid 
    gridTitle: {
      ...stylesheet.SubTitle,
    },
    gridTitleMargin: {
      [mediaQueries.Mobile]: {
        paddingLeft: spacing.GutterGrid.Mobile / 2,
        paddingRight: spacing.GutterGrid.Mobile / 2,
        paddingTop: spacing.Gutter.Mobile,
        paddingBottom: spacing.Gutter.Mobile,

        fontSize: '1.25rem'
      },
      [mediaQueries.Tablet]: {
        paddingLeft: spacing.GutterGrid.Tablet / 2,
        paddingRight: spacing.GutterGrid.Tablet / 2,
        paddingTop: spacing.Gutter.Tablet * 0.75,
        paddingBottom: spacing.Gutter.Tablet * 0.75,
      },
      [mediaQueries.Laptop]: {
        paddingLeft: spacing.GutterGrid.Laptop / 2,
        paddingRight: spacing.GutterGrid.Laptop / 2,
        paddingTop: spacing.Gutter.Laptop * 0.75,
        paddingBottom: spacing.Gutter.Laptop * 0.75,
      },
      [mediaQueries.Desktop]: {
        paddingLeft: spacing.GutterGrid.Desktop / 2,
        paddingRight: spacing.GutterGrid.Desktop / 2,
        paddingTop: spacing.Gutter.Desktop * 0.75,
        paddingBottom: spacing.Gutter.Desktop * 0.75,
      },
      [mediaQueries.BigDesktop]: {
        paddingLeft: spacing.GutterGrid.BigDesktop / 2,
        paddingRight: spacing.GutterGrid.BigDesktop / 2,
        paddingTop: spacing.Gutter.BigDesktop * 0.75,
        paddingBottom: spacing.Gutter.BigDesktop * 0.75,
      },
    },
  }));

export type Exhibitions = ExhibitionsDto;

type Props = Exhibitions;

const Exhibitions: FC<Props> = (props) => {
  const cls = useStyles();
  const { location: { search } } = useRouter();

  const { ExhibitionsItems, NewsItems, UID, SectionTitle } = props;

  useEffect(() => {
    if (!search) { return };
    const elt = document.getElementById(UID);

    if (elt) {
      elt.scrollIntoView({ behavior: 'smooth' });
    }
  }, [])

  return (
    <div className={cls.root}>

      <section className={classNames(cls.section, cls.sectionNews)}>
        <div className={cls.sliderOuter}>
          <Diaporama items={NewsItems} />
        </div>
      </section>
      <section
        className={classNames(cls.section, cls.sectionExhibitions)}
        id={`${UID}`}
      >
        <h5 className={classNames(cls.gridTitle, cls.gridTitleMargin)}>{SectionTitle}</h5>
        <div className={cls.content}>
          {
            ExhibitionsItems && ExhibitionsItems.map((item, i) =>
              <ExhibitionsPreview {...item} key={item.UID} delayIndex={i} />)
          }
        </div>
      </section>
    </div>
  );
};

export default Exhibitions;


// WEBPACK FOOTER //
// ./src/Components/Exhibitions.tsx